import React from 'react';

export const clientInfoContext = React
  .createContext
  /* optional default value */
  ();
